<template>
  <div>
    <el-row :gutter="10">
      <CardTotals
        class="TEcolor"
        :columnCardsSpan="4"
        ColumnCardHeader="Cantidad de Empleados"
        :EmployeesQTY="EmployeesDataQTY"
      />
      <CardTotals
        class="TFcolor"
        :columnCardsSpan="4"
        ColumnCardHeader="Cantidad Fijos"
        :EmployeesQTY="FixedEmployeesDataQTY"
      />
      <CardTotals
        class="TMcolor"
        :columnCardsSpan="4"
        ColumnCardHeader="Cantidad Mujeres"
        :EmployeesQTY="FemEmployeesDataQTY"
      />
      <CardTotals
        class="THcolor"
        :columnCardsSpan="4"
        ColumnCardHeader="Cantidad Hombres"
        :EmployeesQTY="MascEmployeesDataQTY"
      />
      <CardTotals
        class="TCcolor"
        :columnCardsSpan="4"
        ColumnCardHeader="Cantidad Contratistas"
        :EmployeesQTY="ContrEmployeesDataQTY"
      />
      <CardTotals
        class="TExcolor"
        :columnCardsSpan="4"
        ColumnCardHeader="Cantidad Extranjeros"
        :EmployeesQTY="ForeignEmployeesDataQTY"
      />
    </el-row>
    <rabbey-toolbox
      :call-new="IsInRole(roles.GerenteRRHH) === true ? callNew : undefined"
      filterables
      @filter-search="onFilterSearch"
    >
      <template>
        <div class="mr-5">
          <DirectionSelector @selection-change="selectionChange" />
          <el-select v-model="StatusFiltered" placeholder="Estado" size="mini">
            <el-option label="Activo" value="ACT"> </el-option>
            <el-option label="Inactivo" value="INA"> </el-option>
          </el-select>
        </div>
      </template>
      <el-col :span="11">
        <el-button
          type="success"
          plain
          round
          icon="el-icon-document"
          size="mini"
          @click="exportToExcel"
        >
          Exportar a Excel
        </el-button>
      </el-col>
    </rabbey-toolbox>

    <rabbey-table2
      ref="rTable"
      index-url="/api/Employees/GetAllEmployee"
      :paginate-from-api="false"
      :actions="actions"
      :columns="columns"
      :search="search"
      :default-params="getParams"
      @rtable-push-action="handleCommand"
    />
    <el-card class="flex-container">
      <el-card
        v-loading="loadingGraph"
        element-loading-text="Cargando Grafico"
        v-if="this.IsInRoles([this.roles.CEO, this.roles.GerenteRRHH])"
        class="box-cardG"
      >
        <h3 v-if="isRender" id="textG">Gráfico de empleados</h3>
        <el-select
          v-if="isRender"
          @change="this.GetDataForChart"
          v-model="direccionODepartamento"
          size="mini"
        >
          <el-option value="Departamento">Departamento </el-option>
          <el-option key="Direccion" value="Direccion">Direccion </el-option>
        </el-select>
        <div class="ChartSize">
          <pie-chart ref="pieChart" :chartDataProp="chartData"></pie-chart>
        </div>
      </el-card>
      <!--
      <el-card
        v-loading="loadingGraph"
        element-loading-text="Cargando Grafico"
        v-if="this.IsInRoles([this.roles.CEO, this.roles.GerenteRRHH])"
        class="box-cardG"
      >
        <h6 v-for="(item, index) in chartData.labels" :key="index">{{ item }}</h6>
      </el-card>
      -->
    </el-card>
    <profile-form ref="pForm" @profile-finally="handleProfileFinally" />

    <el-dialog
      title="Seleccione el Motivo de Salida"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-select
        v-model="MotiveForDeletion"
        placeholder="Motivo de salida"
        size="mini"
        filterable
        v-bind="$attrs"
      >
        <el-option
          v-for="item in reasonOfExit"
          :key="item.Value"
          :label="item.Label"
          :value="item.Value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="confirmDialog">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<!--@EmployeeData="GetEmployeeData"-->
<script>
// import ImagePersonByEmployee from "@/components/functionals/ImagePersonByEmployee.vue";
import { ColumnsEmployeeACT, ColumnsEmployeeINA } from "./columns/columns";
import ProfileForm from "./ProfileForm";
import { formatDate, FormatCedula } from "@/utils";
import DirectionSelector from "@/components/Company/DirectionSelector.vue";
import CardTotals from "@/components/Card/CardTotals.vue";
import { exportExcel } from "@/helpers/exportExcel";
import PieChart from "@/components/Charts/PolarAreaChart.vue";
export default {
  name: "ProfilesList",
  components: {
    ProfileForm,
    DirectionSelector,
    CardTotals,
    PieChart
  },

  data() {
    return {
      loadingGraph: false,
      isRender: false,
      direccionODepartamento: "Direccion",
      chartData: {
        labels: [],
        datasets: [
          {
            borderWidth: 1,

            borderColor: [],

            backgroundColor: [],

            data: []
          }
        ]
      },
      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      },
      search: "",
      directionID: null,
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      dialogVisible: false,
      MotiveForDeletion: "",
      reasonOfExit: [
        {
          Value: "Desahucio por parte del empleador",
          Label: "Desahucio por parte del empleador"
        },
        {
          Value: "Desahucio por parte del trabajador (Renuncia)",
          Label: "Desahucio por parte del trabajador (Renuncia)"
        },
        { Value: "Despido del trabajador", Label: "Despido del trabajador" },
        { Value: "Dimisión del trabajador", Label: "Dimisión del trabajador" }
      ],
      loading: false,
      items: [],
      columnCardsSpan: 8,
      ColumnCardHeader: "",
      StatusFiltered: "",
      RatioONominal: "",
      EmployeesDataQTY: 0,
      columns: ColumnsEmployeeACT,
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          icon: "el-icon-view",
          label: "Contacto Emergencia",
          command: "view-contacts",
          condition: () => {
            return this.IsInRoles([this.roles.ContactoEmergente]);
          }
        },
        {
          icon: "el-icon-delete",
          label: "Cambiar Estatus",
          command: "inact",
          condition: () => {
            return this.IsInRoles([this.roles.GerenteRRHH]);
          }
        }
      ]
    };
  },

  created() {},

  async mounted() {
    await this.GetEmployees();
    await this.GetDataForChart();
  },
  computed: {
    getParams() {
      // console.log("hola: ", this.directionID)
      return {
        companyId: this.currentCompany,
        estado: this.StatusFiltered,
        directionID: this.directionID
      };
    },
    getParamsCards() {
      // console.log("hola: ", this.directionID)
      return {
        params: {
          companyId: this.currentCompany,
          estado: this.StatusFiltered,
          directionID: this.directionID
        }
      };
    },
    FixedEmployeesDataQTY() {
      let FixEmp = this.items.filter(
        (emp) => emp.IsContractor === false
      ).length;
      return FixEmp;
    },
    FemEmployeesDataQTY() {
      let femQTY = this.items.filter(
        (emp) => emp.Sex === 1 && emp.IsContractor === false
      ).length;
      return femQTY;
    },
    MascEmployeesDataQTY() {
      let femQTY = this.items.filter(
        (emp) => emp.Sex === 0 && emp.IsContractor === false
      ).length;
      return femQTY;
    },
    ContrEmployeesDataQTY() {
      let FixEmp = this.items.filter((emp) => emp.IsContractor === true).length;
      return FixEmp;
    },
    ForeignEmployeesDataQTY() {
      let ForeignEmp = this.items.filter(
        (emp) => emp.IsForeigner === true
      ).length;
      return ForeignEmp;
    }
  },
  methods: {
    async GetDataForChart() {
      this.loadingGraph = true;

      this.chartData.labels = [];
      this.chartData.datasets[0].data = [];
      this.chartData.datasets[0].backgroundColor = [];
      if (this.direccionODepartamento == "Direccion") {
        await this.$http
          .get("/api/Employees/GetEmployeesByDirection")
          .then(({ data }) => {
            data.forEach((element) => {
              this.chartData.labels.push(
                `${element.departamento},( ${element.cantidad} emp., ${(
                  (element.cantidad / this.EmployeesDataQTY) *
                  100
                ).toFixed(2)}%)`
              );
              this.chartData.datasets[0].data.push(element.cantidad);
              this.chartData.datasets[0].backgroundColor.push(
                `#${Math.floor(Math.random() * 16777215).toString(16)}`
              );
            });
          });
      }
      if (this.direccionODepartamento == "Departamento") {
        await this.$http
          .get("/api/Employees/GetEmployeesByDepartment")
          .then(({ data }) => {
            data.forEach((element) => {
              this.chartData.labels.push(
                `${element.departamento},( ${element.cantidad} emp., ${(
                  (element.cantidad / this.EmployeesDataQTY) *
                  100
                ).toFixed(2)}%)`
              );
              this.chartData.datasets[0].data.push(element.cantidad);
              this.chartData.datasets[0].backgroundColor.push(
                `#${Math.floor(Math.random() * 16777215).toString(16)}`
              );
            });
          });
      }

      this.renderDataForChart();
    },

    renderDataForChart() {
      this.$refs.pieChart.RerenderChart(this.chartData, this.options);
      this.loadingGraph = false;
      this.isRender = true;
    },

    formatDate,
    handleProfileFinally() {
      this.$refs.rTable.initialTable();
    },

    async GetEmployees() {
      await this.$http
        .get("/api/Employees/GetAllEmployee", this.getParamsCards)
        .then((response) => {
          //console.log("GetEmployees respuesta employees: ", response)
          this.items = response.data;
          this.EmployeesDataQTY = response.data.length;

          //return response.data.length
          //console.log("Lista de empleados items: ", this.items)
        });
    },

    onFilterSearch(s) {
      this.search = s;
    },
    callNew() {
      this.callForm("create");
    },

    callForm(type) {
      if (type === "create") {
        this.$refs.pForm.renderForm({}, "create");
      }
    },
    editStatus(id) {
      this.$confirm("Segura/o que desea cambiar el Estatus al Empleado?");
      this.$http
        .post(`/api/Employees/DisableStatus/${id}`)
        .then(() => {
          this.$message({
            type: "success",
            message: "Actualizado"
          });
        })
        .catch(() => {
          this.$message.error("Error!");
        })
        .finally(() => {
          this.drawer = false;
          this.drawerLoading = false;
        });
    },
    editStatusEmployee(id) {
      this.$confirm("Segura/o que desea cambiar el Estatus al Empleado?")
        .then(() => {
          this.$http
            .put(
              `/api/Employees/disable?id=${id}&motiveForDeletion=${this.MotiveForDeletion}`
            )
            .then(() => {
              this.$message({
                type: "success",
                message: "Estatus Actualizado"
              });
            })
            .catch(() => {
              this.message.error("Error!");
            })
            .finally(() => {
              // this.getData();
              this.$refs.rTable.initialTable();
              this.getParams;
              this.drawer = false;
              this.drawerLoading = false;
              this.form = {};
            });
        })
        .catch(() => {});
    },
    handleCommand(option) {
      const isValid = this.IsInRole(this.roles.GerenteRRHH);
      const isContactEmergent = this.IsInRole(this.roles.ContactoEmergente);

      if (
        (option.command === "edit" && !isValid) ||
        (option.command === "view" && !isValid) ||
        (option.command === "inact" && !isValid) ||
        (option.command === "view-contacts" && !isContactEmergent)
      ) {
        this.$message.warning("Lo sentimos usted no tiene acceso");
      } else {
        this.$refs.pForm.renderForm(option.row, option.command);
      }
      if (option.command === "inact") {
        if (this.StatusFiltered == "ACT" || this.StatusFiltered == "") {
          this.EmployeeIdDisable = option.row.ID;
          this.dialogVisible = true;
          return;
        }
        this.editStatusEmployee(option.row.ID);
      }
    },
    confirmDialog() {
      this.editStatusEmployee(this.EmployeeIdDisable);
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    selectionChange(DirectionID) {
      this.directionID = DirectionID;
      //console.log("Direction: ", DirectionID, "\n search: ", this.search )
      this.getParams();
    },
    /*
    GetEmployeeData(data) {
      console.log("respuesta employees: ", data) 
    },
    */
    async exportToExcel() {
      let columnNames = this.columns
        .map((column) => {
          return column.name;
        })
        .concat(["Cédula", "Ingreso", "Cumpleaños"]);
      let columnsData = this.items.map((item) => {
        return [
          item.Name,
          item.Direccion.Name,
          item.Deparmento.Name,
          item.Posicion.Name,
          item.Supervisor.Name,
          item.Email,
          item.Fleet,
          item.Extension,
          item.No_Pase,
          FormatCedula(item.DocumentNumber),
          item.StartDate.slice(0, 10),
          item.DateOfBirth.slice(0, 10)
        ];
      });
      let fileTitle = "Lista de Empleados";

      await exportExcel(columnNames, columnsData, fileTitle);
    }
  },
  watch: {
    StatusFiltered(v) {
      this.columns =
        v == "ACT" || v == "" ? ColumnsEmployeeACT : ColumnsEmployeeINA;
    }
  }
};
</script>

<style scoped>
.box-cardG {
  width: 780px;
  position: relative;
  right: 50px;
}
.TEcolor {
  background-color: rgba(61, 223, 201, 0.884);
}
.TFcolor {
  background-color: rgba(73, 245, 102, 0.884);
}
.TMcolor {
  background-color: rgba(233, 102, 163, 0.952);
}
.THcolor {
  background-color: rgba(38, 106, 233, 0.884);
}
.TCcolor {
  background-color: rgba(107, 175, 214, 0.884);
}
.TExcolor {
  background-color: rgba(180, 165, 122, 0.884);
}
.box-cardG {
  width: 780px;
  /* position: relative; */
  right: 50px;
  margin: 0 auto;
}
.flex-container {
  display: flex;
  /*flex-flow: row wrap;*/
  justify-content: center;
  height: 100%;
  width: 100%;
  margin-top: 50px;
}
</style>
